<script setup>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronUpIcon } from "lucide-vue-next";
import { twMerge } from "tailwind-merge";

const props = defineProps({
    title: {
        type: String,
        required: true,
    },
    class: String,
});
</script>
<template>
    <Disclosure as="div" v-slot="{ open }">
        <DisclosureButton
            :class="
                twMerge(
                    open ? 'border-b' : '',
                    'w-full flex justify-between px-6 py-3 text-sm font-medium text-left text-gray-900 border-t border-gray-300 dark:text-white dark:border-gray-800 dark:hover:bg-gray-900 focus:outline-none focus-visible:ring-gray-500/75 focus-visible:ring hover:bg-gray-50',
                    props.class
                )
            ">
            <span>{{ title }}</span>
            <ChevronUpIcon :class="open ? 'rotate-180 transform' : ''" class="w-5 h-5 text-gray-900 dark:text-white" />
        </DisclosureButton>
        <DisclosurePanel>
            <div class="p-3">
                <slot></slot>
            </div>
        </DisclosurePanel>
    </Disclosure>
</template>
